import React from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { decrementQuantity, incrementQuantity, removeCart } from '../redux/features/cartSlice';
import { MdDeleteSweep } from "react-icons/md";

const Cart = () => {
  const {items} = useSelector((state) => state.cart);
  const dispatch = useDispatch();

  const handleRemoveCart = (id) => {
    dispatch(removeCart(id))
  }
  const handleincrementQuantity = (id) =>{
    dispatch(incrementQuantity(id))
  }
  const handledecrementQuantity = (id) =>{
    dispatch(decrementQuantity(id))
  }
  const getTotalProduct =() => {
    let total = 0;
    for(let i=0;i<items.length ;i++){
      total+=items[i].quantity *items[i].price
    }
    return total
  }
  
 
  return (
    <div className="p-4">
      <h2 className="text-2xl font-semibold mb-4">Panier</h2>
     
  {items.length > 0 ? (
    <div className="relative overflow-x-auto shadow-md sm:rounded-lg">
    <table className="w-full text-sm text-left rtl:text-right text-gray-900">
        <thead className="text-xs uppercase  border-b-2 border-gray-200 bg-gray-100 text-gray-900">
            <tr>
                <th scope="col" className="px-6 py-3">
                    Image
                </th>
                <th scope="col" className="px-6 py-3">
                    Product name
                </th>
                <th scope="col" className="px-6 py-3">
                    Description
                </th>
                <th scope="col" className="px-6 py-3">
                    Price
                </th>
                <th scope="col" className="px-6 py-3">
                    Qauantity
                </th>
                <th scope="col" className="px-6 py-3">
                    Taotal
                </th>
                <th scope="col" className="px-6 py-3">
                    Action<span className="sr-only">Delete</span>
                </th>
            </tr>
        </thead>
        <tbody>
          {items.map((item) => (
            <tr key={item.id} className="bg-white border-b hover:bg-gray-100">
               <td className="px-6 py-4">
                   <img src={item.image} alt={item.name} width='60' />
                </td>
            <td className="px-6 py-4">
                    {item.name}
                </td>
                <td className="px-6 py-4">
                {item.description}
                </td>
            
                <td className="px-6 py-4">
                    {item.price}
                </td>
                <td className="px-6 py-4">

                   <button onClick={() => handledecrementQuantity(item.id)} >-</button>

                   <span className='p-8'>{item.quantity}</span> 

                    <button onClick={() => handleincrementQuantity(item.id)}>+</button>
                </td>
                <td className="px-6 py-4">
                    {item.price * item.quantity} MAD
                </td>
                <td className="px-6 py-4 text-right">
                    <button onClick={() =>handleRemoveCart(item.id)}><MdDeleteSweep size={25} /></button>
                </td>
            </tr>
          ))}
        </tbody>
    </table>
    <p>Total Products:{getTotalProduct()}</p>
    </div>
  ) : ( <p>Votre panier est vide.</p>
    
  )}




    
  </div>
  )
}

export default Cart